export var Base64EncoderDecoder = {

    init: function()
    {
        console.log('base 64');
        Base64EncoderDecoder.base64Encode();
        Base64EncoderDecoder.base64Decode();
    },

    base64Encode: function()
    {
        $("#main .base64-encoder-container form").validate({
            submitHandler: function(form) {

                var formData = $('#main .base64-encoder-container form').serialize();

                $.ajax({
                    type: "POST",
                    data: formData,
                    url: "base64-encoder/encode",
                    success: function(data) {
                        if (data != "") {
                            var jsonData = JSON.parse(data);
                            $('#main .base64-encoder-container .tool-output #base64-output').val(jsonData);
                        }
                    }
                });
            }
        });
    },

    base64Decode: function()
    {
        $("#main .base64-decoder-container form").validate({
            submitHandler: function(form) {

                var formData = $('#main .base64-decoder-container form').serialize();

                $.ajax({
                    type: "POST",
                    data: formData,
                    url: "base64-encoder/decode",
                    success: function(data) {
                        if (data != "") {
                            var jsonData = JSON.parse(data);
                            $('#main .base64-decoder-container .tool-output #base64-output').val(jsonData);
                        }
                    }
                });
            }
        });
    }
}
